import React from 'react';

import type { TooltipProps } from '@mui/material';
import { AlineAvatar, AlineAvatarGroup, AlineTooltip } from 'src/components';
import type { Apollo } from 'src/gql/generated';

type AvatarGroupUser = Pick<Apollo.User, 'avatarColor' | 'displayName' | '__typename'>;

interface UsersAvatarGroupProps<TUser extends AvatarGroupUser> {
  users: TUser[];
  fallbackString?: string;
  /** Override each avatar's tooltip — e.g. to explain what clicking the group does. */
  getTooltipTitle?: (user: TUser) => React.ReactNode;
  max?: number;
  tooltipPlacement?: TooltipProps['placement'];
}

export function UsersAvatarGroup<TUser extends AvatarGroupUser>({
  fallbackString = 'Unassigned',
  getTooltipTitle,
  max = 3,
  tooltipPlacement = 'bottom',
  users,
}: UsersAvatarGroupProps<TUser>): JSX.Element {
  if (!users.length)
    return (
      <AlineTooltip arrow placement={tooltipPlacement} title={fallbackString}>
        <AlineAvatar />
      </AlineTooltip>
    );

  return (
    <AlineAvatarGroup max={max}>
      {users.map((user, index) => {
        return (
          <AlineTooltip
            key={index}
            arrow
            placement={tooltipPlacement}
            title={getTooltipTitle ? getTooltipTitle(user) : user.displayName}
          >
            <AlineAvatar avatarInfo={user} />
          </AlineTooltip>
        );
      })}
    </AlineAvatarGroup>
  );
}
